<template>
  <div>
    <!-- Navbar -->
    <div :class="['navBar', { shifted: isSidebarOpen }]">
      <div class="textClass">
        <div class="logoClass">
          <img class="imgTw" src="@/assets/TuitionWave.png" alt="TuitionWave" />
        </div>
        <h2>More Teacher Details</h2>
        <div class="loginClass">
          <MoreDetailsHeader/>
        </div>
      </div>
    </div>

    <!-- Sidebar -->
    <div :class="['sidebar', { open: isSidebarOpen }]">
      <button class="toggle-btn" @click="toggleSidebar">
        <i class="bi" :class="isSidebarOpen ? 'bi bi-layout-sidebar-inset' : 'bi bi-layout-sidebar-inset-reverse'"></i>
      </button>
      <ul class="sidebar-list">
  <li>
    <i class="bi bi-arrow-left-circle" @click="goBack"></i>
    <span v-if="isSidebarOpen">Go Back</span>
  </li>
  <li @click="setActiveContent('moreDetailsView')">
    <i class="bi bi-card-text"></i>
    <span v-if="isSidebarOpen">More Details</span>
  </li>
  <li @click="setActiveContent('teacherDetailsView')">
    <i class="bi bi-person-badge"></i>
    <span v-if="isSidebarOpen">Teacher View</span>
  </li>
  <li @click="setActiveContent('itemDetailsView')">
    <i class="bi bi-box-seam"></i>
    <span v-if="isSidebarOpen">Item View</span>
  </li>
  <li @click="setActiveContent('accountDetailsView')">
    <i class="bi bi-wallet2"></i>
    <span v-if="isSidebarOpen">Account View</span>
  </li>
  <li @click="setActiveContent('instituteDetailsView')">
    <i class="bi bi-building"></i>
    <span v-if="isSidebarOpen">Institute View</span>
  </li>
  <li @click="setActiveContent('tLogDetailsView')">
    <i class="bi-clipboard-data"></i>
    <span v-if="isSidebarOpen">Log Details View</span>
  </li>
  <li @click="setActiveContent('settings')">
    <i class="bi bi-gear"></i>
    <span v-if="isSidebarOpen">Settings</span>
  </li>
</ul>

    </div>

    <!-- Main Content -->
    <div :class="['main-content', { shifted: isSidebarOpen }]">
      <!-- More Details View -->
      <div v-if="activeContent === 'moreDetailsView'">
        <h3>More Details View</h3>
        <p>More details go here...</p>
        <ViewMoreTeacher :teacherId="teacherId"/>
      </div>

      <!-- Institute View -->
      <div v-if="activeContent === 'teacherDetailsView'">
        <h3>Teacher View</h3>
        <p>Details about the institute go here...</p>
        <ViewTeacherDetails :teacherId="teacherId"/>
      </div>
      <div v-if="activeContent === 'itemDetailsView'">
        <h3>Item View</h3>
        <p>Details about the institute go here...</p>
        <ViewItemDetails :teacherId="teacherId"/>
      </div>

      <div v-if="activeContent === 'accountDetailsView'">
        <h3>Account View</h3>
        <p>Details about the institute go here...</p>
        <ViewAccountDetails :teacherId="teacherId"/>
      </div>

      <div v-if="activeContent === 'instituteDetailsView'">
        <h3>Institute View</h3>
        <p>Details about the institute go here...</p>
      </div>

      <div v-if="activeContent === 'tLogDetailsView'">
        <h3>Log Details View</h3>
        <p>Details about the Loging Info go here...</p>
        <ViewTLogDetails :teacherId="teacherId"/>
      </div>

      <!-- Settings -->
      <div v-if="activeContent === 'settings'">
        <h3>Settings</h3>
        <p>Settings options will be available here...</p>
      </div>
    </div>
  </div>
</template>

<script>
import MoreDetailsHeader from '@/components/MoreDetails/moreDetailsHeader.vue';
import ViewMoreTeacher from '@/components/Teacher/TeacherMoreDetails/ViewMoreTeacher.vue';
import ViewTeacherDetails from '@/components/Teacher/TeacherMoreDetails/ViewTeacherDetails.vue';
import ViewItemDetails from '@/components/Teacher/TeacherMoreDetails/ViewItemDetails.vue'
import ViewAccountDetails from '@/components/Teacher/TeacherMoreDetails/ViewAccountDetails.vue'
import ViewTLogDetails from '@/components/Teacher/TeacherMoreDetails/ViewTLogDetails.vue';

export default {
  components: {
    ViewMoreTeacher,
    MoreDetailsHeader,
    ViewTeacherDetails,
    ViewItemDetails,
    ViewAccountDetails,
    ViewTLogDetails,
  },
  data() {
    return {
      isSidebarOpen: false, // State to toggle sidebar
      activeContent: 'moreDetailsView', // Default content to show
      teacherId: null, // Initialize teacherId to null
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    setActiveContent(content) {
      this.activeContent = content;
    },
    goBack() {
          this.$router.push({ path: '/adminHome?currentPage=home', query: { currentPage: 'teachers' } });
        },
  },
  created() {
    // Get the teacherId from the query params when the component is created
    const teacherId = this.$route.query.teacherId;
    if (teacherId) {
      this.teacherId = Number(teacherId); // Convert to number
    }
  },
};
</script>

<style lang="scss" scoped>
/* Navbar Styles */
.navBar {
  max-width: 100%;
  left: 60px;
  right: 0;
  height: 60px;
  position: fixed;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.582);
  top: 0;
  z-index: 50;
  transition: margin-left 0.3s ease;
}

.navBar.shifted {
  margin-left: 140px; /* Matches the sidebar's open width */
}

.textClass {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logoClass {
  display: flex;
  position: absolute;
  left: 5px;
}

.imgTw {
  width: 50px;
  height: 50px;
}

.loginClass {
  position: absolute;
  right: 5px;
}

// .profile-photo {
//   width: 30px;
//   height: 30px;
//   border-radius: 50%;
//   overflow: hidden;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }

// .profile-photo img {
//   width: 100%;
//   height: auto;
//   border-radius: 50%;
// }

/* Sidebar Styles */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #343a40;
  color: white;
  padding: 15px;
  transition: width 0.3s ease;
  overflow: hidden;
  z-index: 100;
  width: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sidebar.open {
  width: 200px;
  align-items: flex-start;
}

.sidebar-list {
  list-style: none;
  padding: 0;
  margin: 10px 0 0;
  width: 100%;
}

.sidebar-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 15px 0;
  cursor: pointer;
  color: #fff;
  padding: 5px 10px;
  width: 100%;
  transition: background-color 0.3s ease;
}

.sidebar-list li:hover {
  background-color: #007bff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-btn {
  background-color: transparent;
  border: none;
  color: white;
  margin: 10px 0;
  cursor: pointer;
  font-size: 1.5rem;
}

.toggle-btn i {
  transition: transform 0.3s ease;
}

.sidebar.open .toggle-btn i {
  transform: rotate(180deg);
}

/* Main Content */
.main-content {
  margin-top: 60px;
  margin-left: 60px;
  padding: 20px;
  transition: margin-left 0.3s ease;
}

.main-content.shifted {
  margin-left: 200px;
}
</style>
